import { withInstall } from '@zoryn/utils'
import DatePickerPanel from './src/date-picker-panel'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZDatePickerPanel: SFCWithInstall<typeof DatePickerPanel> =
  withInstall(DatePickerPanel)

export default ZDatePickerPanel
export * from './src/constants'
export * from './src/props/date-picker-panel'
export * from './src/types'
export type { DatePickerPanelInstance } from './src/instance'
